<template>
  <div v-if="!doNotRender" ref="map" :style="styleProps" />
</template>
<script>
export default {
  name: "GoogleMap",
  props: {
    styleProps: {
      type: String,
      default: "width: 100%;height:300px;"
    },
    position: {
      type: Object,
      default: () => ({ lat: 0, lng: 0 })
    },
    markerDraggable: {
      type: Boolean,
      default: false
    },
    mapTypeId: {
      type: String,
      default: "roadmap"
    },
    zoom: {
      type: [String, Number],
      default: 5
    },
    markers: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUI: true
      })
    }
  },
  data() {
    return {
      map: null,
      currentMarkers: [],
      doNotRender: false
    };
  },
  watch: {
    markers(v) {
      this.currentMarkers.forEach(marker => {
        marker.setMap(null); // remove from map
      });
      this.currentMarkers = v.map(this._markerLoop);
      this.map.setCenter(v[0]);
    },
    zoom(v) {
      this.map.setZoom(Number(v));
    }
  },
  mounted() {
    if (!window.google) {
      this.doNotRender = true;
      return;
    }
    const maps = window.google.maps;
    var myLatlng = new maps.LatLng(this.position.lat, this.position.lng);
    var mapOptions = {
      zoom: this.zoom,
      center: myLatlng,
      mapTypeId: this.mapTypeId,
      mapId: process.env.VUE_APP_GOOGLE_MAPS_MAP_ID ?? "DEMO_MAP_ID",
      ...this.options
    };

    this.map = new maps.Map(this.$refs.map, mapOptions);
    this.currentMarkers = this.markers.map(this._markerLoop);
  },
  methods: {
    _markerLoop(marker) {
      const mapMarker = new window.google.maps.marker.AdvancedMarkerElement({
        position: new window.google.maps.LatLng(marker.lat, marker.lng),
        map: this.map,
        gmpDraggable: this.markerDraggable
      });

      mapMarker.addListener("dragend", value => {
        this.$emit("dragend", {
          lng: value.latLng.lng(),
          lat: value.latLng.lat()
        });
      });
      return mapMarker;
    }
  }
};
</script>
